module.exports = __webpack_public_path__ + "images/shop/favicon-kfzteile-com/favicon.ico";